// @flow

import React from 'react'
import ReputationStarWithCount from 'components/shared/ReputationStarWithCount'

export type PropTypes = {
  name: string,
  reputationScore: number,
  reputationsCount: number,
  spaceTypeUrl: string,
  stateUrl: string,
  capacityUrl: string,
  reputationsUrl: string,
  spaceName: string,
  capacity: string,
  stateText: string,
}

export default (props: Object) => (
  <div>
    <h1 className="space-head__title" itemProp="name">
      {props.name}
    </h1>
    <ul className="space-head__list link__subcolor">
      <li className="space-head__list-star">
        <ReputationStarWithCount
          score={props.reputationScore}
          count={props.reputationsCount}
          link={props.reputationsUrl}
          size={'medium'}
        />
      </li>
      <li className="space-head__list-user">
        <i className="fa fa-user mr5" />
        {props.capacity ? (
          <a href={props.capacityUrl}>
            {i18n.t('page.room.capacity', { capacity: props.capacity })}
          </a>
        ) : (
          <span>-</span>
        )}
      </li>
      <li className="space-head__list-map">
        <i className="fa fa-map-marker mr5" />
        <a href={props.stateUrl}>{props.stateText}</a>
      </li>
      <li className="space-head__list-tag">
        <i className="fa fa-tag mr5" />
        <a href={props.spaceTypeUrl}>{props.spaceTypeText}</a>
      </li>
    </ul>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailHeader/index.jsx